import _toConsumableArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { DensityShape } from '../shape';
import { MaybeZeroY1, MaybeZeroX } from '../transform';
import { baseGeometryChannels, basePostInference, basePreInference, tooltip1d } from './utils';
var shape = {
  density: DensityShape
};
export var Density = function Density() {
  return function (index, scale, value, coordinate) {
    var X = value.x,
      S = value.series;
    var Yn = Object.entries(value).filter(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 1),
        key = _ref2[0];
      return key.startsWith('y');
    }).map(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
        value = _ref4[1];
      return value;
    });
    var SZn = Object.entries(value).filter(function (_ref5) {
      var _ref6 = _slicedToArray(_ref5, 1),
        key = _ref6[0];
      return key.startsWith('size');
    }).map(function (_ref7) {
      var _ref8 = _slicedToArray(_ref7, 2),
        value = _ref8[1];
      return value;
    });
    // Because x and y channel is not strictly required in Line.props,
    // it should throw error with empty x or y channels.
    if (X === undefined || Yn === undefined || SZn === undefined) {
      throw new Error('Missing encode for x or y or size channel.');
    }
    // Calc width for each box.
    // The scales for x and series channels must be band scale.
    var xScale = scale.x;
    var series = scale.series;
    var P = Array.from(index, function (i) {
      var groupWidth = xScale.getBandWidth(xScale.invert(+X[i]));
      var ratio = series ? series.getBandWidth(series.invert(+(S === null || S === void 0 ? void 0 : S[i]))) : 1;
      var width = groupWidth * ratio;
      var offset = (+(S === null || S === void 0 ? void 0 : S[i]) || 0) * groupWidth;
      var x = +X[i] + offset + width / 2;
      var PN = [].concat(_toConsumableArray(Yn.map(function (_, idx) {
        return [x + +SZn[idx][i] / index.length, +Yn[idx][i]];
      })), _toConsumableArray(Yn.map(function (_, idx) {
        return [x - +SZn[idx][i] / index.length, +Yn[idx][i]];
      }).reverse()));
      return PN.map(function (p) {
        return coordinate.map(p);
      });
    });
    return [index, P];
  };
};
Density.props = {
  defaultShape: 'density',
  defaultLabelShape: 'label',
  composite: false,
  shape: shape,
  channels: [].concat(_toConsumableArray(baseGeometryChannels({
    shapes: Object.keys(shape)
  })), [{
    name: 'x',
    scale: 'band',
    required: true
  }, {
    name: 'y',
    required: true
  }, {
    name: 'size',
    required: true
  }, {
    name: 'series',
    scale: 'band'
  }, {
    name: 'size',
    required: true,
    scale: 'identity'
  }]),
  preInference: [].concat(_toConsumableArray(basePreInference()), [{
    type: MaybeZeroY1
  }, {
    type: MaybeZeroX
  }]),
  postInference: [].concat(_toConsumableArray(basePostInference()), _toConsumableArray(tooltip1d())),
  interaction: {
    shareTooltip: true
  }
};